import * as components from './src/components'
import AppService from '@/services/app.service';
import router from '@/router';

import UserDetailsExtended from './src/components/profile/userDetails.vue';

// Flags um mehrfache Ausführung zu verhindern
let routesAdded = false;
let linksAdded = false;

export default {
  // called by Vue.use(FirstPlugin)
  install(Vue) {
    Vue.component('UserDetailsExtended', UserDetailsExtended);

    // register the component with vue
    Object.values(components).forEach(component => {
      if (component.name && component.name !== 'userDetails') {
        Vue.component(component.name, component);
      }
    })

    // Core Components Extension - EINMALIG im install()
    AppService.extendCoreComponents([
      'components/video/videoDataTable',
      'components/profile/userDetails',
      'components/profile/registerForm',
      'components/player/videoInsightsActions/vActions'
    ]);

    // Mixin für Route/Link-Registrierung - benötigt App-Instanz
    Vue.mixin({
      beforeCreate() {
        // Nur bei der Haupt-App-Komponente ausführen (uid === 3) und nur einmal
        if (this._uid === 3 && !routesAdded) {
          routesAdded = true;
          AppService.addRoutes(this, [
            {
              path: '/einnahmen',
              name: 'einnahmen',
              component: 'liox-mediathek-shop/src/views/einnahmen',
              beforeEnter: router.guard,
              meta: {
                roles: ['ROLE_TENANT', 'ROLE_USER'],
                product: 'Starter',
                label: 'shop.nav.einnahmen'
              },
            },
            {
              path: '/',
              name: 'video-shop',
              component: 'liox-mediathek-shop/src/views/video-shop',
              meta: {}
            },
            {
              path: '/subcheckout',
              name: 'subcheckout',
              beforeEnter: router.guard,
              component: 'liox-mediathek-shop/src/views/subcheckout',
              meta: {
                roles: ['ROLE_TENANT', 'ROLE_USER', 'ROLE_END_USER'],
                product: 'Starter'
              }
            },
            {
              path: '/ageVerification',
              name: 'ageverification',
              component: 'liox-mediathek-shop/src/views/ageVerification',
              beforeEnter: router.guard,
              meta: {
                roles: ['ROLE_TENANT', 'ROLE_USER', 'ROLE_END_USER'],
                product: 'Starter'
              },
            },
            {
              path: '/shop-video/:id',
              name: 'shop-video',
              component: 'liox-mediathek-shop/src/views/shop-video',
              meta: {}
            },
            {
              path: '/order-checkout',
              name: 'ccbill_checkout',
              component: 'liox-mediathek-shop/src/views/ccbill_checkout',
              meta: {
                roles: ['ROLE_TENANT', 'ROLE_USER', 'ROLE_END_USER'],
                product: 'Starter'
              },
            }
          ]);
        }
      },

      created() {
        // Nur bei der Haupt-App-Komponente ausführen
        if (this.menuItems && !linksAdded) {
          linksAdded = true;
          AppService.addLinks(this, [
            {
              path: '/einnahmen',
              name: 'shop.nav.einnahmen',
              icon: 'mdi-currency-eur',
              beforeEnter: router.guard,
              meta: {
                roles: ['ROLE_TENANT', 'ROLE_USER'],
                product: 'Starter',
                label: 'shop.nav.einnahmen'
              },
              index: 1
            }
          ]);
        }
      }
    });
  },
};
